// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import "./styles/global.css";

import Home from "./pages/Home/Home";
import ProjectsAll from "./pages/ProjectsAll/ProjectsAll";
import ProjectDetail from "./pages/ProjectDetail/ProjectDetail";

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<ProjectsAll />} />
        <Route path="/projects/:key" element={<ProjectDetail />} />
      </Routes>
    </BrowserRouter>
  );
}
